export const AssetGroupsGenericTypes = {
  Car: 1,
  Bike: 2,
  Motorbike: 3,
  Truck: 4,
  Accessory: 5,
}
